import { Link } from "react-router-dom";

export default function AboutPage() {
  document.title = "About ROAS-AI | Beruf LLC - AI Marketing Platform";
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-zinc-300 py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/login" className="text-violet-400 hover:text-violet-300 text-sm mb-8 inline-block">&larr; Back to ROAS-AI</Link>

        <h1 className="font-heading text-4xl text-white font-bold mb-2">About Us</h1>
        <p className="text-zinc-400 mb-10">The team behind ROAS-AI</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-white text-lg font-semibold mb-3">Our Mission</h2>
            <p>ROAS-AI is built by Beruf LLC to help marketers maximize their advertising return across every platform. We believe that managing ad spend across Google, Meta, LinkedIn, and Microsoft shouldn't require jumping between four dashboards, manually comparing metrics, and guessing where to allocate your next dollar.</p>
            <p className="mt-3">Our platform brings all your campaigns into one place, uses AI to analyze performance, and optimizes budgets automatically based on what's actually working.</p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">What We Do</h2>
            <p>ROAS-AI connects to your advertising accounts across Google Ads, Meta (Facebook & Instagram) Ads, LinkedIn Ads, and Microsoft (Bing) Ads. We sync your campaigns, ad groups, and individual ads into a unified dashboard where you can:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li><span className="text-white">Monitor performance</span> across all platforms in real time with unified KPIs</li>
              <li><span className="text-white">Optimize budgets</span> using our blended performance scoring that weighs ROAS, conversions, clicks, and impressions</li>
              <li><span className="text-white">Get AI-powered insights</span> from our Advisor, which analyzes your data and provides actionable marketing recommendations with charts and visualizations</li>
              <li><span className="text-white">Manage Budget Groups</span> to allocate and optimize spend across sets of campaigns automatically</li>
              <li><span className="text-white">Archive and pause campaigns</span> with automatic syncing to the respective ad platforms</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">Our Company</h2>
            <div className="bg-[#121212] border border-white/10 rounded-xl p-6 space-y-3">
              <div className="flex justify-between">
                <span className="text-zinc-400">Company</span>
                <span className="text-white">Beruf LLC</span>
              </div>
              <div className="flex justify-between">
                <span className="text-zinc-400">Product</span>
                <span className="text-white">ROAS-AI</span>
              </div>
              <div className="flex justify-between">
                <span className="text-zinc-400">Address</span>
                <span className="text-white text-right">701 Tillery Street, Unit 12-1574<br />Austin, Texas 78702<br />United States</span>
              </div>
              <div className="flex justify-between">
                <span className="text-zinc-400">Website</span>
                <a href="https://roas-ai.com" className="text-violet-400 hover:text-violet-300">roas-ai.com</a>
              </div>
              <div className="flex justify-between">
                <span className="text-zinc-400">Contact</span>
                <a href="mailto:contact@roas-ai.com" className="text-violet-400 hover:text-violet-300">contact@roas-ai.com</a>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">Security & Privacy</h2>
            <p>We take the security of your data seriously. ROAS-AI implements SOC2 code-level controls including audit logging, rate limiting, session management, and password policy enforcement. We only access your ad platform data through authorized OAuth connections, and you can disconnect any platform at any time.</p>
            <p className="mt-3">
              Read our <a href="/privacy" className="text-violet-400 hover:text-violet-300">Privacy Policy</a> and <a href="/terms" className="text-violet-400 hover:text-violet-300">Terms of Service</a> for full details.
            </p>
          </section>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 text-zinc-500 text-xs text-right">
          Copyright (c) 2026 Beruf LLC
        </div>
      </div>
    </div>
  );
}
